import React, { useEffect, useState } from 'react';
import { DadosAbaSumario, TipoDemanda, getDemanda, getSumario } from '@app/api/demanda';
import { Card, Collapse, Icon, Row, Col, Input } from 'antd';
import { dadosGeraisState, demandaIdState, desabilitarAcoesState, ordemCompraIdState } from '../atoms';
import { useRecoilValue } from 'recoil';
import { isValidGuid } from '@app/helpers/geradorGuid';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { FormSelect, MasterDetailForm, Widget } from '@digital/ui';
import moment from 'moment';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import { hasPermission } from '@app/helpers/permissions';
import { getAllCompradores, updateUsuarioCompradorOrdemCompra } from '@app/api/sas/ordemCompra';
import ButtonModalCancelarOc from './ButtonModalCancelarOc';
import { getLoggedId } from '@app/helpers';
import CaracterizaçãoGeralDemanda from './CaracterizacaoGeralDemanda';
import CaracterizaçãoGeralDemandaFaturamentoDireto from './CaracterizacaoGeralDemandaFaturamentoDireto';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';

const WidgetSumario = () => {
  const demandaId = useRecoilValue(demandaIdState);
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const dadosGerais = useRecoilValue(dadosGeraisState);
  const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);
  const [loggedId] = useState(getLoggedId() || '');

  const [sumarioData, setSumarioData] = useState<DadosAbaSumario | undefined>();
  const [demandaData, setDemandaData] = useState();
  const [loading, setLoading] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [spans, setSpans] = useState({ min: 6, max: 18 });
  const [order, setOrder] = useState(true);

  const setWidth = () => {
    setScreenWidth(window.innerWidth);
  };
  window.addEventListener('resize', setWidth);
  useEffect(() => {
    if (screenWidth <= 1360) {
      setSpans({ min: 8, max: 24 });
      setOrder(false);
    } else {
      setSpans({ min: 6, max: 18 });
      setOrder(true);
    }
  }, [screenWidth]);

  useEffect(() => {
    if (isValidGuid(demandaId)) {
      getSumario(demandaId).then(data => {
        if (data) {
          setSumarioData(data);
          setLoading(false);
        }
      });
      getDemanda(demandaId).then(data => {
        if (data) setDemandaData(data);
      });
    }
  }, [demandaId]);

  const handleSelectComprador = (compradorId: string) => {
    updateUsuarioCompradorOrdemCompra({
      ordemCompraId: ordemCompraId,
      usuarioCompradorId: compradorId,
    }).then(data => {
      if (data) {
      }
    });
  };
  const validationComprador = () => isObjNotEmpty(dadosGerais) && dadosGerais.compradorId == loggedId;

  return (
    <>
      {' '}
      {isObjNotEmpty(demandaData) && demandaData && isObjNotEmpty(sumarioData) && sumarioData && (
        <Collapse
          className="aba-sumario"
          bordered={false}
          defaultActiveKey={'analise'}
          expandIcon={() => <Icon type="arrows-right_4" />}>
          <Collapse.Panel key="analise" header={`OC - ${sumarioData.ordemCompra}`}>
            <Widget className={`aba-sumario`} actions={[validationComprador() ? <ButtonModalCancelarOc /> : null]}>
              <Row gutter={12} type="flex" className="row-global">
                <Col span={24} order={0}>
                  <MasterDetailForm initialValues={dadosGerais}>
                    <FormSelect
                      getOptions={getAllCompradores}
                      onSelect={(e: any) => handleSelectComprador(e)}
                      name="compradorId"
                      label="Comprador Responsável"
                      span={4}
                      disabled={!hasPermission(['SAS_ALTERAR_COMPRADOR']) || desabilitarAcoes}
                      showSearch
                      filterOption={(input, item: any) => {
                        return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                      }}
                    />
                  </MasterDetailForm>
                </Col>

                <>
                  {demandaData.statusCodigo === 7 && (
                    <Col span={24} style={{ paddingBottom: '16px' }}>
                      <label>Justificativa de cancelamento</label>
                      <Input.TextArea
                        id="mrn-textarea-justificativaCancelamento"
                        disabled
                        value={demandaData.justificativaCancelamento}
                      />
                    </Col>
                  )}
                </>

                {demandaData.tipo === ETipoDemanda.FaturamentoDireto ? (
                  <CaracterizaçãoGeralDemandaFaturamentoDireto
                    sumarioData={sumarioData}
                    span={spans.max}
                    order={order ? 1 : 0}
                  />
                ) : (
                  <CaracterizaçãoGeralDemanda sumarioData={sumarioData} span={spans.max} order={order ? 1 : 0} />
                )}
                <Col span={spans.min} order={order ? 0 : 1}>
                  <Card title="Dados Gerais" bordered={false} className="card-sumario">
                    <Row>
                      {' '}
                      <div className="content">
                        <span className="card-list">
                          <span className="card-list-title w60">Data de Abertura da Demanda: </span>
                          <span className="card-list-content w40">
                            {moment(sumarioData.dataAbertura).format(dateFormat)}
                          </span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w20">Demandante: </span>
                          <span className="card-list-content w80">{sumarioData.demandante}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w20">Requisitante: </span>
                          <span className="card-list-content w80">{sumarioData.requisitante}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w30">Gestor Técnico: </span>
                          <span className="card-list-content w70">{sumarioData.gestorTecnico}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w20">Diretoria: </span>
                          <span className="card-list-content w80">{sumarioData.diretoria}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w20">Área: </span>
                          <span className="card-list-content w80">{sumarioData.area}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w30">Departamento: </span>
                          <span className="card-list-content w70">{sumarioData.departamento}</span>
                        </span>
                      </div>
                    </Row>
                  </Card>
                </Col>
                <Col span={spans.min} order={2}>
                  <Card title="Caracterização de Valor da Demanda" bordered={false} className="card-sumario">
                    <Row>
                      <div className="content">
                        <span className="card-list">
                          <span className="card-list-title w60">Valor Atual: </span>
                          <span className="card-list-content w40">{sumarioData.valorAtual}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Valor Aditivo: </span>
                          <span className="card-list-content w40">{sumarioData.valorAditivo}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Valor Total: </span>
                          <span className="card-list-content w40">
                            {demandaData.tipo === ETipoDemanda.FaturamentoDireto
                              ? sumarioData.valorPedido
                              : sumarioData.novoValorFinal}
                          </span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Tipo de Despesa: </span>
                          <span className="card-list-content w40">{sumarioData.tipoDespesa}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Alocação de Custo: </span>
                          <span className="card-list-content w40">{sumarioData.alocacaoDeCusto}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w40">Item de Serviço: </span>
                          <span className="card-list-content w60 objeto-encurtado">{sumarioData.itemServico}</span>
                        </span>
                      </div>
                    </Row>
                  </Card>
                </Col>
                <Col span={spans.min} order={3}>
                  <Card title="Dados da RC/OC" bordered={false} className="card-sumario">
                    <Row>
                      <div className="content">
                        <span className="card-list">
                          <span className="card-list-title w60">Número RC: </span>
                          <span className="card-list-content w40">{sumarioData.requisicaoCompra}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Número OC: </span>
                          <span className="card-list-content w40">{sumarioData.ordemCompra}</span>
                        </span>
                        <hr />
                        {
                        <span className="card-list">
                          <span className="card-list-title w60">Emergencial: </span>
                          <span className="card-list-content w40">{sumarioData.isEmergencial}</span>
                        </span>
                        }
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Direcionada: </span>
                          <span className="card-list-content w40">{sumarioData.isFornecedorDirecionado}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Previsão Orçamentária: </span>
                          <span className="card-list-content w40">{sumarioData.temPrevisaoOrcamentaria}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Comprador: </span>
                          <span className="card-list-content w40">{sumarioData.comprador}</span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">Data de Criação da RC: </span>
                          <span className="card-list-content w40">
                            {sumarioData.dataCriacaoRc ? moment(sumarioData.dataCriacaoRc).format(dateFormat) : 'N/A'}
                          </span>
                        </span>
                        <hr />
                        <span className="card-list">
                          <span className="card-list-title w60">
                            {' '}
                            {demandaData.tipo != ETipoDemanda.FaturamentoDireto
                              ? 'Aprovação da OC:'
                              : 'Aprovação da Demanda:'}{' '}
                          </span>
                          <span className="card-list-content w40">
                            {sumarioData.aprovacaoOc ? moment(sumarioData.aprovacaoOc).format(dateFormat) : 'N/A'}
                          </span>
                        </span>
                      </div>
                    </Row>
                  </Card>
                </Col>
                {demandaData.tipo != ETipoDemanda.FaturamentoDireto ? (
                  <>
                    <Col span={spans.min} order={4}>
                      <Card title="Governança de Contratos" bordered={false} className="card-sumario">
                        <Row>
                          <div className="content">
                            <span className="card-list">
                              <span className="card-list-title w60">Elegibilidade Governança: </span>
                              <span className="card-list-content w40">
                                {sumarioData.eligibilidadeGovernancaAprovacao}
                              </span>
                            </span>
                            <hr />
                            <span className="card-list">
                              <span className="card-list-title w40">Critério - Valor: </span>
                              <span className="card-list-content w60">{sumarioData.criterioValorGovernanca}</span>
                            </span>
                            <hr />
                            <span className="card-list">
                              <span className="card-list-title w70">Critério - Orçamento: </span>
                              <span className="card-list-content w30">{sumarioData.temPrevisaoOrcamentaria}</span>
                            </span>
                            <hr />
                            <span className="card-list">
                              <span className="card-list-title w60">Resultado CCI: </span>
                              <span className="card-list-content w40">{sumarioData.resultadoCCI}</span>
                            </span>
                            <hr />
                            <span className="card-list">
                              <span className="card-list-title w40">Rota Aprovação: </span>
                              <span className="card-list-content w60">{sumarioData.rotaAprovacao}</span>
                            </span>
                          </div>
                        </Row>
                      </Card>
                    </Col>
                    <Col span={spans.min} order={5}>
                      <Card title="DDI - Due Diligence de Integridade" bordered={false} className="card-sumario">
                        <Row>
                          <div className="content">
                            <span className="card-list">
                              <span className="card-list-title w60">Elegibilidade DDI: </span>
                              <span className="card-list-content w40">{sumarioData.ddi}</span>
                            </span>
                            <hr />
                            <span className="card-list">
                              <span className="card-list-title w60">Critério - Prazo: </span>
                              <span className="card-list-content w40">{sumarioData.criterioPrazoDDI}</span>
                            </span>
                            <hr />
                            <span className="card-list">
                              <span className="card-list-title w60">Critério - Valor: </span>
                              <span className="card-list-content w40">{sumarioData.criterioValorDDI}</span>
                            </span>
                            <hr />
                            <span className="card-list">
                              <span className="card-list-title w70">Critério - Categoria Serviço: </span>
                              <span className="card-list-content w30">{sumarioData.categoriaDDI}</span>
                            </span>
                            <hr />
                            <span className="card-list">
                              <span className="card-list-title w70">Critério - Rel. Entidade Publica: </span>
                              <span className="card-list-content w30">{sumarioData.relacionamentoEntidadePublica}</span>
                            </span>
                            <hr />
                            <span className="card-list">
                              <span className="card-list-title w70">Critério - Elegibilidade Governança: </span>
                              <span className="card-list-content w30">
                                {sumarioData.eligibilidadeGovernancaAprovacao}
                              </span>
                            </span>
                          </div>
                        </Row>
                      </Card>
                    </Col>
                  </>
                ) : (
                  <Col span={spans.min} order={5}>
                    <Card title="DDI - Due Diligence de Integridade" bordered={false} className="card-sumario">
                      <Row>
                        <div className="content">
                          <span className="card-list">
                            <span className="card-list-title w60">Elegibilidade DDI: </span>
                            <span className="card-list-content w40">{sumarioData.ddi}</span>
                          </span>
                          <hr />
                          <span className="card-list">
                            <span className="card-list-title w60">Critério - Prazo: </span>
                            <span className="card-list-content w40">{sumarioData.criterioPrazoDDI}</span>
                          </span>
                          <hr />
                          <span className="card-list">
                            <span className="card-list-title w60">Critério - Valor: </span>
                            <span className="card-list-content w40">{sumarioData.criterioValorDDI}</span>
                          </span>
                          <hr />

                          <span className="card-list">
                            <span className="card-list-title w80">Mão-de-obra em PTR: </span>
                            <span className="card-list-content w20">{sumarioData.haveraMaoDeObraEmPTR}</span>
                          </span>
                          <hr />
                          <span className="card-list">
                            <span className="card-list-title w70">Critério - Rel. Entidade Publica: </span>
                            <span className="card-list-content w30">{sumarioData.relacionamentoEntidadePublica}</span>
                          </span>
                          <hr />
                        </div>
                      </Row>
                    </Card>
                  </Col>
                )}
              </Row>
            </Widget>
          </Collapse.Panel>
        </Collapse>
      )}
    </>
  );
};

export default WidgetSumario;
